import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommExAppSelectionList } from "./autogen/AutogenLayoutMobileCommExAppSelectionList";
import { DataSourceExecutionEvent, TableSelectionEvent } from "@mcleod/components";

export class MobileCommExAppSelectionList extends AutogenLayoutMobileCommExAppSelectionList {

    /** This is an event handler for the afterExecution event of sourceExAppSelections. */
    sourceExAppSelectionsAfterExecution(event: DataSourceExecutionEvent) {
        event.data?.data?.selections?.forEach(element => {
            const row = new ModelRow(null, true,
                { section: element.section, field: element.field, value: element.value, field_name: element.field_name });
            this.tableSelections.addRow(row, {}, { addToData: true, display: true });
        });
    }

    async tableSelectionsOnSelect(event: TableSelectionEvent): Promise<void> {
        const selectedRow = event.newRow;
        if (selectedRow) {

            const fieldName = selectedRow.data.get("field_name");

            // Find and focus the textbox with matching sequence value
            const allChildren = this.owner.tabsetMobileCommControl.getRecursiveChildren();
            for (const component of allChildren) {
                if (component.field === fieldName) {
                    component.focus();
                    break;
                }
            }
        }
    }
}
